import { render, staticRenderFns } from "./BillingDescription.vue?vue&type=template&id=6ca0e164&scoped=true"
import script from "./BillingDescription.vue?vue&type=script&lang=js"
export * from "./BillingDescription.vue?vue&type=script&lang=js"
import style0 from "./BillingDescription.vue?vue&type=style&index=0&id=6ca0e164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0e164",
  null
  
)

export default component.exports